import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
      if (!this.authService.isLoggedUser()) {
          this.router.navigate(['/login']);
        }
  }

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/pages/dashboard/dashboard.component.ts